module.exports = __webpack_public_path__ + "static/media/3.44d14759.jpg";